import { ShieldCheck, Lock, CreditCard } from "lucide-react";

export default function PassportPage() {
  return (
    <div className="h-full flex items-center justify-center p-8 animate-in fade-in zoom-in duration-1000">
      <div className="max-w-md w-full border border-black p-12 space-y-8 relative overflow-hidden bg-white shadow-[20px_20px_0px_0px_rgba(0,0,0,0.03)]">
        {/* Aesthetic Background Pattern */}
        <div className="absolute top-0 right-0 p-4 opacity-[0.03] select-none pointer-events-none">
          <ShieldCheck className="w-64 h-64 -mr-20 -mt-20" />
        </div>

        <div className="space-y-6 relative z-10">
          <div className="w-12 h-16 border-2 border-black flex items-center justify-center font-serif font-bold text-2xl">
            N
          </div>
          
          <div className="space-y-2">
            <h1 className="font-serif text-4xl italic tracking-tighter">Diplomatic Passport</h1>
            <p className="text-[10px] uppercase tracking-[0.4em] text-black/40 font-mono font-bold">Status: Pending Mint</p>
          </div>

          <div className="h-[1px] bg-black/10 w-full" />

          <div className="space-y-4">
            <p className="font-serif italic text-slate-600 leading-relaxed">
              The onchain representation of your physical movement. This passport will serve as a 
              verifiable credential across the Network Protocol.
            </p>
            
            <div className="flex items-center gap-2 text-blue-600 bg-blue-50 px-3 py-2 border border-blue-100 inline-flex">
              <Lock className="w-3 h-3" />
              <span className="text-[9px] font-mono uppercase font-bold tracking-widest">Protocol V0.2: Smart Contract Integration</span>
            </div>
          </div>
        </div>

        <div className="pt-8 flex justify-between items-end relative z-10">
          <div className="space-y-1">
            <p className="text-[8px] font-mono uppercase text-slate-400">Security Clearance</p>
            <p className="text-xs font-mono font-bold">LEVEL-01-UNVERIFIED</p>
          </div>
          <CreditCard className="w-8 h-8 text-black/10" />
        </div>
      </div>
    </div>
  );
}